var _defs, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconShareReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1258",
    "data-name": "Group 1258",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2623",
    "data-name": "Rectangle 2623",
    width: 40,
    height: 40,
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_426",
    "data-name": "Line 426",
    d: "M-2.751.634A.932.932,0,0,1-3.563.16.933.933,0,0,1-3.21-1.111L1.127-3.563A.933.933,0,0,1,2.4-3.21.933.933,0,0,1,2.045-1.94L-2.292.513A.928.928,0,0,1-2.751.634Z",
    transform: "translate(19.602 18.447)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_427",
    "data-name": "Line 427",
    d: "M1.372.5A.928.928,0,0,1,.916.378L-3.208-1.938a.933.933,0,0,1-.356-1.27.933.933,0,0,1,1.27-.356L1.829-1.248A.933.933,0,0,1,2.186.022.932.932,0,0,1,1.372.5Z",
    transform: "translate(19.687 25.62)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1257",
    "data-name": "Group 1257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1256",
    "data-name": "Group 1256",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M37.7,71.134a5.154,5.154,0,1,1,5.154-5.153A5.159,5.159,0,0,1,37.7,71.134Zm0-8.443a3.289,3.289,0,1,0,3.289,3.29A3.293,3.293,0,0,0,37.7,62.691Z",
    transform: "translate(-24.309 -45.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M82.982,33.339a5.154,5.154,0,1,1-5.154,5.153A5.159,5.159,0,0,1,82.982,33.339Zm0,8.442a3.288,3.288,0,1,0-3.289-3.289A3.293,3.293,0,0,0,82.982,41.781Z",
    transform: "translate(-58.124 -24.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M82.982,96.656A5.154,5.154,0,1,1,88.136,91.5,5.159,5.159,0,0,1,82.982,96.656Zm0-8.442a3.289,3.289,0,1,0,3.289,3.29A3.293,3.293,0,0,0,82.982,88.214Z",
    transform: "translate(-58.124 -64.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M.933,15.622A.933.933,0,0,1,0,14.689V5.244A5.249,5.249,0,0,1,5.244,0h9.5a.933.933,0,0,1,0,1.865h-9.5A3.382,3.382,0,0,0,1.866,5.244v9.445A.933.933,0,0,1,.933,15.622Z",
    transform: "translate(0 0.014)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M14.748,111.92h-9.5A5.249,5.249,0,0,1,0,106.678V97.233a.933.933,0,1,1,1.865,0v9.445a3.382,3.382,0,0,0,3.378,3.378h9.5a.933.933,0,0,1,0,1.865Z",
    transform: "translate(0 -71.906)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M111.159,15.622a.933.933,0,0,1-.933-.933V5.244a3.382,3.382,0,0,0-3.378-3.379H97.461a.933.933,0,1,1,0-1.865h9.387a5.249,5.249,0,0,1,5.243,5.244v9.445A.933.933,0,0,1,111.159,15.622Z",
    transform: "translate(-72.091 0.014)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M106.846,111.92H97.459a.933.933,0,1,1,0-1.865h9.387a3.382,3.382,0,0,0,3.379-3.378V97.233a.933.933,0,1,1,1.865,0v9.445A5.249,5.249,0,0,1,106.846,111.92Z",
    transform: "translate(-72.089 -71.906)",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareReport);
export default __webpack_public_path__ + "static/media/icon-share-report.10a7c2879364a2b855c7597601d804a9.svg";
export { ForwardRef as ReactComponent };